import React from "react";

export class PanelHeading extends React.Component {
    render() {
        return (
            <div className={"panel-heading"}>
                {this.props.children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/panel/PanelHeading.js